import React from 'react';
import ProjectItem from '../../../Domain/ProjectItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OperationsProjectService from '../../../Services/OperationsProjectService';
import selectHelper from '../../../Helpers/selectHelper';

class EditProjectWindowDescription extends React.Component {
  static titleForCreate = 'Add New Project';
  static titleForEdit = 'Edit Project';
  static itemType = ProjectItem;
  static serviceFunction = (edited) => OperationsProjectService.EditProject(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Please provide basic information about this Project.',
      fields: [
        {
          fieldName: 'CfName',
          label: 'Project *',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CfCoid',
          label: 'Contact *',
          className: 'col-6',
          type: InputTypesEnum.ContactSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'CfCcid',
        },
        {
          fieldName: 'CfProjectManagerId',
          label: 'Project Manager *',
          className: 'col-6',
          type: InputTypesEnum.ProjectManagerSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CfReimbTypeText',
          label: 'Reimbursement Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.IsInvoiced === true,
          selectvalues: EditProjectWindowDescription.getReimbursementTypeSelectOptions(),
        },
        {
          fieldName: 'CfStartDate',
          label: 'Start Date *',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disableClearButton: true,
        },
        {
          fieldName: 'CfEndDate',
          label: 'End Date *',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: EditProjectWindowDescription.validityCheckerForStartAndEndDate,
          disableClearButton: true,
        },
        {
          fieldName: 'CfComments',
          label: 'Summary',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getCreditTypeSelectOptions() {
    return selectHelper.generateSelectValues(['Credit Percent', 'Credit Amount']);
  }

  static getReimbursementTypeSelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      'Use Apollo Shopper Reimbursement Field',
      'Use Apollo Client Reimbursement Field',
    ]);
  }

  static validityCheckerForStartAndEndDate(e, editedItem) {
    if (editedItem) {
      return new Date(editedItem.CfStartDate) > new Date(editedItem.CfEndDate)
        ? 'End Date must be later than Start Date.'
        : '';
    }
    return '';
  }

  static validityCheckerMsPartner(e, editedItem) {
    if (editedItem === undefined) return '';
    if (editedItem.IsMspartner === false) return '';
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    return '';
  }
}

export default EditProjectWindowDescription;
